import { render, staticRenderFns } from "./NixiaConnectionStatus.vue?vue&type=template&id=2615a30f&scoped=true&"
import script from "./NixiaConnectionStatus.vue?vue&type=script&lang=js&"
export * from "./NixiaConnectionStatus.vue?vue&type=script&lang=js&"
import style0 from "./NixiaConnectionStatus.vue?vue&type=style&index=0&id=2615a30f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2615a30f",
  null
  
)

export default component.exports